import { createContext, useState, useCallback } from 'react';

export const ModalContext = createContext({});

export const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState({});

  // Abrir modal
  const openModal = useCallback((modalId, data = null) => {
    setModals((prev) => ({
      ...prev,
      [modalId]: { isOpen: true, data },
    }));
  }, []);

  // Fechar modal
  const closeModal = useCallback((modalId) => {
    setModals((prev) => ({
      ...prev,
      [modalId]: { isOpen: false, data: null },
    }));
  }, []);

  // Fechar todos os modals
  const closeAllModals = useCallback(() => {
    setModals({});
  }, []);

  // Verificar se modal está aberto
  const isModalOpen = useCallback((modalId) => {
    return modals[modalId]?.isOpen || false;
  }, [modals]);

  // Obter dados do modal
  const getModalData = useCallback((modalId) => {
    return modals[modalId]?.data || null;
  }, [modals]);

  const value = {
    modals,
    openModal,
    closeModal,
    closeAllModals,
    isModalOpen,
    getModalData,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
